module.exports = __webpack_public_path__ + "static/img/vouchers506.d9f36c7a.png";